import React from 'react';
import { IProposta } from '../../utility/IProposta';
import CabecalhoCardDemanda from './CabecalhoCardDemanda';
import DadosClienteProcessoCardDemanda from './DadosClienteProcessoCardDemanda';
import DadosCorrespondenteCardDemanda from './DadosCorrespondenteCardDemanda';
import DadosAudienciaCardDemanda from './DadosAudienciaCardDemanda';
import { Container } from './styles';

interface CardDemandaProps {
  proposta?: IProposta;
}

const mockProposta: IProposta = {
  id_proposta: 19001,
  id_usuario: 101,
  id_servico: 202,
  id_comarca: 303,
  numero_processo: '5678901-23.2024.8.19.0001',
  nome_cliente: 'Advocacia Nordeste AL #50001',
  valor_cliente: 'R$ 2.500,00',
  codigo_cliente: '29012',
  prazo_aceite: '2024-07-01',
  prazo_para_conclusao: '2024-07-10',
  dias_uteis_para_conclusao: '7',
  orientacoes: 'Comparecer ao fórum com antecedência de 30 minutos.',
  tipo_audiencia: 'Audiência',
  data: '2024-07-05',
  profissional_necessario: 'Advogado',
  modalidade: 'Presencial',
  endereco_virtual: '',
  rua: 'Rua das Flores',
  bairro: 'Centro',
  cep: '01001-000',
  numero: '123',
  complemento: 'Sala 45',
  valor_profissional: 'R$ 1.000,00',
  pendente_de_orientacao: 'false',
  tipo: 'Demanda',
  status: 'Pendente',
  qtd_arquivos: 2
};


export default function CardDemanda({ proposta }: CardDemandaProps = {}) {
  proposta = proposta || mockProposta;

  // Verificar se os componentes têm dados para exibir
  const temDadosCorrespondente = !!(proposta.id_usuario && proposta.id_usuario !== 0) || !!(proposta.nome_profissional || proposta.whatsapp || proposta.email);
  const temDadosAudiencia = !!(proposta.rua || proposta.numero || proposta.bairro || proposta.complemento || proposta.cep || proposta.endereco_virtual);

  return (
    <Container>
      <CabecalhoCardDemanda proposta={proposta} showDivider={false} />
      <DadosClienteProcessoCardDemanda proposta={proposta} showDivider={temDadosCorrespondente || temDadosAudiencia} />
      {temDadosCorrespondente && (
        <DadosCorrespondenteCardDemanda proposta={proposta} showDivider={temDadosAudiencia} />
      )}
      {temDadosAudiencia && (
        <DadosAudienciaCardDemanda proposta={proposta} showDivider={false} />
      )}
    </Container>
  );
} 